import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import WhiteSpinner from 'commonComponents/whiteSpinner';
import { colors } from 's1-ui';

const { primaryNavy, neutralWhite } = colors;

const styles = {
  pageContainer: {
    backgroundColor: primaryNavy,
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  text: {
    color: neutralWhite,
    fontSize: 35,
    fontWeight: 100,
    paddingTop: 200
  },
  progress: {
    paddingTop: 100
  }
};

export const UnstyledAccountSpinner = ({ classes }) => (
  <div className={ `CCP_AccountSpinner__Container ${classes.pageContainer}` }>
    <div className={ classes.text }>
      Setting up your account...
    </div>
    <div className={ classes.progress }>
      <WhiteSpinner size={ 100 } />
    </div>
  </div>
);

UnstyledAccountSpinner.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UnstyledAccountSpinner);
